var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.style)},[_c('Icon',{attrs:{"name":"spinner","size":_vm.size,"align":_vm.align,"pulse":_vm.pulse,"spin":_vm.spin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }